/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2019 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H133162 on 7/17/2019.
 *
 */

import {apiUrl, handleApiCall} from './HttpUtils'

const getPredictiveIndicatorsOnAssetApi = (assetId) => {
    return apiUrl(`assets/${assetId}/predictiveIndicators`)
}

const getPredictiveIndicatorsOnFaultApi = (assetId, faultId) => {
    return apiUrl(`assets/${assetId}/faults/${faultId}/predictiveIndicators`)
}

const getAffectedFaultsByPredictiveIndicatorApi = (assetId, predictiveIndicatorId) => {
    return apiUrl(`assets/${assetId}/predictiveIndicators/${predictiveIndicatorId}`)
}

export const fetchPredictiveIndicatorsOnAsset = (assetId, search, criticalityLimit) => {
    let query = '?start=0'
    if (criticalityLimit != null) {
        query += '&criticalityLimit=' + criticalityLimit
    }
    if (search !== '') {
        query += '&search=' + search;
    }
    return handleApiCall(getPredictiveIndicatorsOnAssetApi(assetId) + query)
}

export const fetchPredictiveIndicatorsOnFault = (assetId, faultId) => {
    return handleApiCall(getPredictiveIndicatorsOnFaultApi(assetId, faultId));
}

export const fetchAffectedFaultsByPredictiveIndicator = (assetId, predictiveIndicatorId) => {
    return handleApiCall(getAffectedFaultsByPredictiveIndicatorApi(assetId, predictiveIndicatorId));
}

